// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 152 ? "7684593d" : chunkId) + "." + {"51":"b974fc7fedf3611e","56":"f49dfe4734eafa45","152":"fb0d10bdb8d7673b","238":"d1a340cb64e955af","543":"440e7cb30ce8226e","565":"cb226527a350474f","889":"0f3073b84ff932ad"}[chunkId] + ".js";
};